/*
 * @Author: your name
 * @Date: 2020-09-28 16:57:38
 * @LastEditTime: 2021-09-18 13:22:54
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \lzxy-homepage\src\commons\bannerManage.ts
 */
import { Banner, Newstitle, ProjectSystem } from './bannerModel'
import { BannerService } from './bannerService'
export class BannerManageImpl {
  banners: Banner[] = []
  Newstitle: Newstitle[] = []
  ProjectSystem: ProjectSystem[] = []
  ProjectSystemId = ''
  service: BannerService
  ProjectSystemList = []
  news: object = {}
  // loading: boolean = false
  constructor (service: BannerService) {
    this.service = service
  }

  public async requestBannerList () {
    const res = await this.service.getBannerService()
    this.banners = res.splice(0, 4)
    console.log(this.banners)
  }

  async getNewstitles () {
    const res = await this.service.getNewsService()
    console.log(res)
    this.Newstitle = res
    console.log(this.Newstitle)
    // this.Newstitle.forEach((item: Newstitle) => {
    //   const res = this.service.getInformationNewsService(1, 5, item.id)
    //   this.news[item.id] = res
    // })
  }

  async getProjectSystem (pid: any) {
    const res = await this.service.getProjectSystemService(pid)
    this.ProjectSystem = res
    console.log(res)
    console.log(this.ProjectSystem)
    for (const i in this.ProjectSystem) {
      const data = this.ProjectSystem[i].projectSystemId
      console.log(data)
      this.ProjectSystemId = data
    }
  }

  async getProjectSystemInfor () {
    const res = await this.service.getProjectSystemInforService(this.ProjectSystemId)
    this.ProjectSystemList = this.getTreeData(res)
    // const aaa = this.ProjectSystemList.children
    console.log(this.ProjectSystemList)
  }

  getTreeData (res: any) {
    return res.filter((item: any) => item.pid === '0').map((item: any) => {
      item.children = res.filter((i: any) => i.pid === item.projectSystemId)
      return item
    })
  }
}
